import Auth from "./auth";
import AuthForms from "./forms";


export {
    AuthForms
};

export default Auth;